module.exports = __webpack_public_path__ + "img/bts-herrick-membership.06322a3d.png";